import { Dialog, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Form, Formik, FormikProps } from 'formik';
import React from 'react';
import toast from 'react-hot-toast';

import { useDialogFormState } from '../dialogForm.hook';
import { DialogMode } from '../types';

import { DialogActions } from './DialogActions';

export interface FormikDialogFormProps<T, C, U> {
  dialogId: string;
  title: React.ReactNode | ((mode: DialogMode) => React.ReactNode);
  onSubmit: (input: C | U, mode: DialogMode) => Promise<T>;
  creationInitialValues: C;
  validationSchema: ((mode: DialogMode) => any) | any;
  loading: boolean;
  form: JSX.Element | ((mode: DialogMode) => JSX.Element);
  formikProps?: FormikProps<C | U>;
}

export function FormikDialogForm<T, C, U>(props: FormikDialogFormProps<T, C, U>) {
  const { open, closeDialog, initialValues, mode } = useDialogFormState<U>(props.dialogId);

  const handleSubmit = (dto: C | U) =>
    props.onSubmit(dto, mode).then(mitarbeiter => {
      if (mitarbeiter) {
        closeDialog();
        const proj = props.title;
        if (proj === 'Projekt bearbeiten') {
          toast.success('Projekt erfolgreich bearbeitet!');
        }
        if (typeof props.title === 'function') {
          const type = props.title(mode);

          if (type === 'Neuer Aufwand') {
            toast.success('Aufwand erfolgreich angelegt!');
          } else if (type === 'Neues Projekt') {
            toast.success('Projekt erfolgreich angelegt!');
          }
          if (type === 'Neuer Mitarbeiter') {
            toast.success('Mitarbeiter erfolgreich angelegt!');
          } else if (type === 'Neuer Kunde') {
            toast.success('Kunde erfolgreich angelegt!');
          }
          if (type === 'Kunde bearbeiten') {
            toast.success('Kunde erfolgreich bearbeitet!');
          }
        }
      }
    });

  return (
    <Dialog open={open} onClose={closeDialog} maxWidth={'lg'} fullWidth={true}>
      <DialogTitle>
        {typeof props.title === 'function' ? props.title(mode) : props.title}
      </DialogTitle>
      <DialogContent style={{ overflow: 'visible' }}>
        <Formik
          initialValues={{ ...props.creationInitialValues, ...initialValues }}
          validationSchema={
            typeof props.validationSchema === 'function'
              ? props.validationSchema(mode)
              : props.validationSchema
          }
          onSubmit={handleSubmit}
        >
          {({ submitForm }) => (
            <Form>
              {typeof props.form === 'function' ? props.form(mode) : props.form}
              <DialogActions
                disabled={props.loading}
                confirm={{
                  label: mode === 'create' ? 'Erstellen' : 'Speichern',
                  onClick: submitForm,
                }}
                cancel={{ onClick: closeDialog }}
              />
              {props.loading && <LinearProgress />}
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
